import type { Padding } from '@floating-ui/react';

import { breakpoints } from '~/styles/media.css';

import { useMediaQuery } from './useMediaQuery';

export const useCollisionPadding = (): Padding => {
  const isMobileNavigationVisible = useMediaQuery(breakpoints.small);

  return isMobileNavigationVisible ? { top: 8, bottom: 100, left: 8, right: 8 } : 8;
};
